import React, { useState } from "react";
import TextComponent from "../../../components/textComponent/TextComponent";
import { TbCreditCardPay, TbEyeClosed } from "react-icons/tb";
import styles from "./AdminPayments.module.css";
import { BiSolidEditAlt } from "react-icons/bi";
import { Carousel, DatePicker, List } from "antd";
import { VscEye } from "react-icons/vsc";
import { DateInput, InputField, SubmitButton } from "../../../components";
import { useNavigate } from "react-router-dom";
import { inputHandler } from "../../../utills";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

const cards = [
  {
    name: "Stacy Doe",
    cardEndDigit: "1289",
    cardType: "master",
    date: "09/25",
  },
  {
    name: "Stacy Doe",
    cardEndDigit: "1289",
    cardType: "master",
    date: "09/25",
  },
  {
    name: "Stacy Doe",
    cardEndDigit: "1289",
    cardType: "master",
    date: "09/25",
  },
];

const earnings = [
  {
    name: "Garage Door Fixing",
    date: "24 Nov’ 24",
    price: "+$256",
    status: "paid",
    image: require("../../../assets/images/staticImages/inboxImg1.png"),
  },
  {
    name: "Garage Door Fixing",
    date: "24 Nov’ 24",
    price: "+$256",
    status: "paid",
    image: require("../../../assets/images/staticImages/inboxImg2.png"),
  },
  {
    name: "Garage Door Fixing",
    date: "24 Nov’ 24",
    price: "+$256",
    status: "pending",
    image: require("../../../assets/images/staticImages/inboxImg3.png"),
  },
  {
    name: "Garage Door Fixing",
    date: "24 Nov’ 24",
    price: "+$256",
    status: "paid",
    image: require("../../../assets/images/staticImages/inboxImg4.png"),
  },
  {
    name: "Garage Door Fixing",
    date: "24 Nov’ 24",
    price: "+$256",
    status: "paid",
    image: require("../../../assets/images/staticImages/inboxImg5.png"),
  },
];

const AdminPayments = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [CardNumber, setCardNumber] = useState("");
  const [CardHolder, setCardHolder] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeadingComponent
          text={"Select Payment method"}
          fontSize={"var(--heading-font-size)"}
        />
        <TextComponent className={styles.Heading} />
      </div>

      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <div className={styles.carosel}>
            {cards?.map((item) => (
              <div className={styles.card}>
                <div className={styles.headCont}>
                  <TextComponent
                    text="Primary Payment Method"
                    color={"var(--white-color)"}
                  />
                  <div className={styles.edit}>
                    <TextComponent text="Edit" color={"var(--white-color)"} />
                    <BiSolidEditAlt size={15} />
                  </div>
                </div>
                <div className={`${styles.headCont} ${styles.nameCont}`}>
                  <TextComponent
                    text={item?.name}
                    className={styles.name}
                    color={"var(--white-color)"}
                  />
                  <div>
                    <img
                      src={require("../../../assets/images/masterCardLogo.png")}
                      alt=""
                      className={styles.img}
                    />
                  </div>
                </div>
                <div className={styles.headCont}>
                  <TextComponent
                    text={"xxxx xxxx xxxx " + item.cardEndDigit}
                    color={"var(--white-color)"}
                  />
                  <div>
                    <TextComponent
                      text={item.date}
                      color={"var(--white-color)"}
                    />
                  </div>
                </div>
              </div>
            ))}
            <SubmitButton
              onClick={() => navigate("/BakerySetup")}
              title={"Buy Subscription"}
              btnContainerClass={styles.btnContainer}
              primary
              btnClass={`${styles.btn}`}
            />
          </div>
        </div>
        <div className={styles.rightCont}>
          <TextComponent text="Add Payment Method " className={styles.bold} />
          <TextComponent
            text="To receive your in-app funds, you need to link a payment method. Add payment method to receive your payments."
            className={styles.desc}
          />
          <InputField
            className={styles.input}
            innerInput={{
              backgroundColor: "var(--input-bg)",
            }}
            inputStyle={{
              backgroundColor: "var(--input-bg) ",
              border: "1px solid var(--input-border)",
            }}
            placeholder={"Card Number"}
            type="number"
            maxLength={16}
            value={CardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
          />
          <InputField
            className={styles.input}
            innerInput={{ backgroundColor: "var(--input-bg)" }}
            inputStyle={{
              backgroundColor: "var(--input-bg)",
              border: "1px solid var(--input-border)",
            }}
            placeholder={"Card Holder"}
            value={CardHolder}
            onChange={(e) => setCardHolder(e.target.value)}
          />
          <DateInput placeholder={"Expiry Date"} />

          <InputField

            innerInput={{ backgroundColor: "var(--input-bg)" }}
            inputStyle={{
              backgroundColor: "var(--input-bg)",
              border: "1px solid var(--input-border)",
            }}
            placeholder={"CVC Code"}
            maxLength={4}
            onKeyPress={(e) => inputHandler(e)}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            // rightIcon={
            //   passwordVisible ? (
            //     <VscEye size={20} color={"var(--input-icon)"} />
            //   ) : (
            //     <TbEyeClosed size={20} color={"var(--input-icon)"} />
            //   )
            // }
            // onRightIconPress={() => setPasswordVisible(!passwordVisible)}
            // type={passwordVisible ? "number" : "password"}
            type={"number"}
          />
          <SubmitButton
            title={"Add Payment Method"}
            btnContainerClass={styles.AddPaymentbtnContainer}
            secondary
            btnClass={`${styles.AddPaymentbtn}`}
            style={{ marginBottom: "20px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminPayments;
